export default __webpack_public_path__ + "static/media/textSortIconDark.3a1bd981.svg";